import React, { memo, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { getData } from '../../../../assets/scripts/GeneralFunctions'
import { toast } from 'react-toastify'
import NewMessageTitle from './child/NewMessageTitle'
import MessageResivers from './child/MessageResivers'
import { textarea_class } from '../../../../functions/stateList'

function SmsNew() {
  const navigate = useNavigate()
  const location = useLocation()

  const [dropdown, setDropdown] = useState(false)
  const [selectedCustomer_types, setSelectedCustomer_types] = useState([])
  const [customerTypes, setCustomerTypes] = useState([])
  const [message, setMessage] = useState({ smsText: '' })

  const inputHandler = (e) => {
    setMessage((prevState) => ({ ...prevState, [e.target.name]: e.target.value }))
  }

  const toogleDropdown = () => {
    setDropdown(!dropdown)
  }

  const addNewSms = async (e) => {
    e.preventDefault()

    if (message.smsText === '' || selectedCustomer_types?.length <= 0) {
      toast.warning('لطفا تمام موارد باید کامل شود')
    } else {
      let formData = new FormData()

      if (selectedCustomer_types?.length > 0) {
        const selectedCustomer_types_Id = selectedCustomer_types.map((element) => element.id)
        for (let i = 0; i < selectedCustomer_types_Id?.length; i++) {
          formData.append(`receivers[${i}]`, selectedCustomer_types_Id[i])
        }

        formData.append(`message`, message?.smsText)
      }

      let apiResult = await getData(`admin/sms/send`, 'post', formData, true, true)
      if (apiResult) {
        navigate('/sms')
        toast.success('پیامک ارسال شد')
      }
    }
  }

  useEffect(() => {
    setCustomerTypes(location?.state?.customerTypes)
  }, [location])

  const { smsText } = message

  return (
    <>
      <NewMessageTitle title={'ارسال'} />
      <MessageResivers
        toogleDropdown={toogleDropdown}
        dropdown={dropdown}
        setSelectedCustomer_types={setSelectedCustomer_types}
        setDropdown={setDropdown}
        selectedCustomer_types={selectedCustomer_types}
        customerTypes={customerTypes}
      />
      <div>
        <form onSubmit={addNewSms}>
          <div className="my-7 w-full">
            <label
              htmlFor="exampleFormControlTextarea1"
              className="form-label inline-block mb-2 text-gray-700 dark:text-gray-200"
            >
              {' '}
              متن پیامک{' '}
            </label>
            <textarea
              className={textarea_class}
              placeholder="متن پیامک را وارد کنید"
              name={'smsText'}
              value={smsText}
              onChange={(e) => inputHandler(e)}
              rows={7}
            />
          </div>
          <button
            type={'submit'}
            className="md:w-fit ml-0 mr-auto shadow-add-more h-11 px-5 py-2.5 text-md font-medium text-white flex items-center justify-center bg-blue rounded-md hover:bg-link transition-all duration-300 ease-linear whitespace-nowrap"
          >
            <span className={'text-white pl-2'}>ارسال پیام</span>
          </button>
        </form>
      </div>
    </>
  )
}

export default memo(SmsNew)
